import { BuyGuideVendorLocationList } from '../../../components/BuyGuide';

export function BuyGuideVendorLocations() {
  return <BuyGuideVendorLocationList />;
}
